var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:{ 'badge-success': _vm.value == 1, 'badge-danger': _vm.value != 1 }},[_vm._v(" "+_vm._s(_vm.value == 1 ? _vm.on : _vm.off)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }